// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rls-dialog__field-name {
  margin-bottom: 5px;
  background: var(--ds-color-gray);
  width: 500px;
  padding: 5px;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/datasets/components/RLSDialog/RLSDialog.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAAR","sourcesContent":[".rls-dialog__field-name {\n  margin-bottom: 5px;\n  background: var(--ds-color-gray);\n  width: 500px;\n  padding: 5px;\n  border-radius: 3px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
